import { FolderItem } from '../types';

/**
 * Helper function to sort folders and items alphabetically
 * Folders are sorted first, then items, both in alphabetical order
 */
export const sortFoldersAndItems = (items: FolderItem[]): FolderItem[] => {
  if (!items || items.length === 0) return items;

  return items.map(item => {
    // If item has children, recursively sort them
    if (item.children && item.children.length > 0) {
      // Separate folders and items
      const folders = item.children.filter(child => child.type === 'folder' || !child.type);
      const actualItems = item.children.filter(child => child.type === 'item');

      // Sort folders alphabetically by name
      const sortedFolders = folders.sort((a, b) => 
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
      );

      // Sort items alphabetically by name
      const sortedItems = actualItems.sort((a, b) => 
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
      );

      // Recursively sort children of folders
      const processedFolders = sortFoldersAndItems(sortedFolders);

      return {
        ...item,
        children: [...processedFolders, ...sortedItems]
      };
    }

    return item;
  }).sort((a, b) => 
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  );
};
